/**
 * Team member sections for Meet the Team page.
 * Add photos to public/ (e.g. heli-social-expert.png, sajud-digital-expert.png, tejas-cfo.png).
 */

const PUBLIC = process.env.PUBLIC_URL || '';

export const SAJUD = {
  id: 'meet-sajud',
  topLine: 'Digital Marketing Expert',
  heading: 'Meet our digital Marketing Expert, Sajud',
  description:
    'Sajud is the Founder of The Wiry and an expert in digital marketing with expertise in SEO, Google My Business, and working strategies for improving brand recognition. He also has website development expertise and enhancing websites, application builder and is a Ph.D. in computer science.',
  image: PUBLIC + '/sajud-digital-expert.png',
  imageAlt: 'Sajud, remarketing expert',
  placeholderText: 'Image placeholder — add sajud-digital-expert.png to the public folder',
  portfolioLink: '', // add e.g. '/sajud' when you have a portfolio page
  portfolioLabel: 'View portfolio',
};

export const HELI = {
  id: 'meet-heli',
  topLine: 'Social Media Expert',
  heading: 'Meet our social media expert, Heli',
  description:
    'Heli leads our social media work and is co-founder of The Wiry. She manages a wide range of social media projects for brands and helps businesses grow and connect with their audiences.',
  image: PUBLIC + '/heli-social-expert.png',
  imageAlt: 'Heli, social media expert and co-founder of the Wiry',
  placeholderText: 'Image placeholder — add heli-social-expert.png to the public folder',
  portfolioLink: '/heli',
  portfolioLabel: 'View portfolio',
};

export const TEJAS = {
  id: 'meet-tejas',
  topLine: 'CFO / Director of Operations',
  heading: 'Meet our Chief Financial Officer, Tejas Godbole',
  description:
    'Tejas brings over 10 years of experience in FinTech . With an MS in Information Systems and an MBA in Finance, he combines technical expertise with strategic financial leadership. SAP Finance certified and AWS certified, Tejas drives operational excellence, financial strategy, and technology innovation to support sustainable business growth',
  image: PUBLIC + '/tejas-cfo.png',
  imageAlt: 'Baal waala Tejas, Chief Financial Officer and Director of Operations',
  placeholderText: 'Image placeholder — add tejas-cfo.png to the public folder',
  portfolioLink: '',
  portfolioLabel: 'View portfolio',
};
